import { render, staticRenderFns } from "./TeacherIndividualAwayAssignmentPage.vue?vue&type=template&id=688e1f00&scoped=true&"
import script from "./TeacherIndividualAwayAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./TeacherIndividualAwayAssignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688e1f00",
  null
  
)

export default component.exports